var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"C_auth-root"},[_c('ConfcallrLogo',{attrs:{"color":"white"}}),_c('vue-loading',{attrs:{"type":"bars","color":"#fff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }